import * as React from "react";
import User from "../../model/user/User";
import MapUtils from "../../utils/MapUtils";
import {getUserLocation} from "../../store/view/user";


interface ComponentProps {
	/**
	 * User presented in row.
	 */
	user: User;
}

type Props = ComponentProps

/**
 * Base engineer list item component.
 */
export default class DayViewEngineerListItem extends React.PureComponent<Props, {}> {
	render() {
		return (
			<div className={"c-engineer-list-item"}>
				<div className={"c-engineer-list-item_avatar"}>
					<img src={MapUtils.getSEInitialsMarker(this.props.user)}/>
				</div>
				<div className={"c-engineer-list-item_details"}>
					{this.props.user.getDisplayName()}
					{this.props.user.disabled ?
						<span>DISABLED</span> :
						<small>{this.getStatus()}</small>}

				</div>
			</div>
		);
	}

	/**
	 * @returns {string} online/offline user status string.
	 */
	getStatus(): string {
		const location = getUserLocation(this.props.user.id);
		const isOffline = location.map(l => l.isOffline()).getOrElse(true);
		return location.map(l => isOffline ? l.createdAt.fromNow() : "Online now").getOrElse("Offline")
	};
}
